import { useIntl } from 'react-intl';

import DeleteIcon from '@evaneos/b2b-ui/icons/DeleteOutlineOutlined';

import { Box, IconButton, Typography } from '@evaneos/b2b-ui';

import { deprecated_868E96 } from '../../../../../../styles/deprecated-colors';

import { DateFormInput } from '../../../../../../design-system/Form/DateFormInput';
import { SidePanelViewMode } from '../../../../SidePanel/types';

import { TextFormInput } from '../TextFormInput';

import s from './TravelersStep.module.css';

type Props = {
    index: number;
    isDeleteTravelerModalOpened: (value: boolean) => void;
    travelerIndexToDelete: (index: number) => void;
    viewMode?: SidePanelViewMode;
};

export const TravelerComponent = ({
    index,
    isDeleteTravelerModalOpened,
    travelerIndexToDelete,
    viewMode,
}: Props): JSX.Element => {
    const intl = useIntl();

    return (
        <div key={index} className={s.line}>
            {viewMode === 'compact' ? (
                <Box
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                        {intl.formatMessage(
                            { id: 'contract.travelers_information.traveler_number' },
                            { num: index + 1 },
                        )}
                    </Typography>

                    <IconButton
                        data-testid={`travelers.${index}.delete`}
                        size="small"
                        onClick={() => {
                            isDeleteTravelerModalOpened(true);
                            travelerIndexToDelete(index);
                        }}
                        aria-label={intl.formatMessage({ id: 'global.delete' })}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Box>
            ) : null}
            <TextFormInput
                name={`travelers.${index}.firstName`}
                label={intl.formatMessage({
                    id: 'contract.travelers_information.first_name',
                })}
            />
            <TextFormInput
                name={`travelers.${index}.lastName`}
                label={intl.formatMessage({
                    id: 'contract.travelers_information.last_name',
                })}
            />
            <TextFormInput
                name={`travelers.${index}.country`}
                label={intl.formatMessage({
                    id: 'contract.travelers_information.country',
                })}
            />
            <DateFormInput
                name={`travelers.${index}.birthDate`}
                label={'contract.travelers_information.birth_date'}
                errorMessage={intl.formatMessage({
                    id: 'contract.travelers_information.errors.birth_date',
                })}
            />
            {viewMode !== 'compact' ? (
                <button
                    type="button"
                    data-testid={`travelers.${index}.delete`}
                    onClick={() => {
                        isDeleteTravelerModalOpened(true);
                        travelerIndexToDelete(index);
                    }}
                    aria-label={intl.formatMessage({ id: 'global.delete' })}
                    className={s.noStyleButton}
                >
                    <DeleteIcon
                        className={s.deleteButton}
                        sx={{
                            color: deprecated_868E96,
                        }}
                    />
                </button>
            ) : null}
        </div>
    );
};
